"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiSelectInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactSelect = require("react-select");
var _ui = require("../../ui");
var _constants = require("../../../constants");
var _Label = require("./Label");
var _excluded = ["tickers"];
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var MultiValue = (0, _styledComponents.default)(_reactSelect.components.MultiValue).attrs(function (props) {
  var valuesLength = props.getValue().length;
  return {
    children: valuesLength === props.options.length ? /*#__PURE__*/_react.default.createElement(_Label.Label, {
      ticker: "ALL"
    }) : valuesLength > 1 ? /*#__PURE__*/_react.default.createElement(_Label.Label, {
      optionsSelected: valuesLength
    }) : props.data.multiValue
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 0 !important;\n  padding: 0 !important;\n  &:not(:first-child) {\n    display: none;\n  }\n"])));
var MultiSelectInput = function MultiSelectInput(_ref) {
  var tickers = _ref.tickers,
    props = _objectWithoutProperties(_ref, _excluded);
  var options = ['ALL'].concat(tickers).map(function (ticker, _i, arr) {
    return {
      value: ticker,
      multiValue: /*#__PURE__*/_react.default.createElement(_Label.Label, {
        ticker: ticker
      }),
      label: /*#__PURE__*/_react.default.createElement(_Label.Label, {
        ticker: ticker,
        showChecked: true,
        checked: props.value.includes(ticker)
      })
    };
  });
  return /*#__PURE__*/_react.default.createElement(_ui.SelectInput, _extends({
    defaultValue: tickers
  }, props, {
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === 8 && !e.target.value) e.preventDefault();
    },
    options: props.value.length !== options.length - 1 && props.value.length ? options : options.slice(1),
    onChange: function onChange(values) {
      if (values.includes('ALL') || !values.length) {
        return props.onChange(options.filter(function (o) {
          return o.value !== 'ALL';
        }).map(function (o) {
          return o.value;
        }));
      }
      props.onChange(values);
    },
    isMulti: true,
    isSearchable: true,
    closeMenuOnSelect: false,
    hideSelectedOptions: false,
    filterOption: function filterOption(_ref2, value) {
      var _TickerFullName;
      var data = _ref2.data;
      if (value && data.value === 'ALL') return false;
      return data.value.includes(value.toUpperCase()) || ((_TickerFullName = _constants.TickerFullName[data.value]) === null || _TickerFullName === void 0 ? void 0 : _TickerFullName.toLowerCase().includes(value.toLowerCase()));
    },
    components: _objectSpread({
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      MultiValueRemove: function MultiValueRemove() {
        return null;
      },
      MultiValue: MultiValue,
      Placeholder: function Placeholder() {
        return /*#__PURE__*/_react.default.createElement(_Label.Label, {
          ticker: "ALL"
        });
      },
      ClearIndicator: function ClearIndicator() {
        return /*#__PURE__*/_react.default.createElement(_ui.SelectClearIndicator, {
          onClick: function onClick() {
            return props.onChange([]);
          }
        });
      }
    }, props.components)
  }));
};
exports.MultiSelectInput = MultiSelectInput;